import { render } from "./forgot_pass.vue?vue&type=template&id=f8e11618&scoped=true"
import script from "./forgot_pass.vue?vue&type=script&lang=js"
export * from "./forgot_pass.vue?vue&type=script&lang=js"

import "./forgot_pass.vue?vue&type=style&index=0&id=f8e11618&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e11618"]])

export default __exports__